import { render, staticRenderFns } from "./ModalVinculoUnidadeAdministrativa.vue?vue&type=template&id=5a540724"
import script from "./ModalVinculoUnidadeAdministrativa.vue?vue&type=script&lang=js"
export * from "./ModalVinculoUnidadeAdministrativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports